export const invalidateFile = /* GraphQL */ `
  query invalidateFile($fileName: String!) {
    invalidateFile(fileName: $fileName)
  }
`;
